import { ModelBase } from '../../core/models/model-base.model';
import { Component } from './component.model';

export class Amount extends ModelBase {
    amount: number;
    component: Component;
}
